var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.05 3.9-.6.45zm-6.8-1.65H6.5V.75H2.25zM1.5 15V3H0v12zm16.25.75H2.25v1.5h15.5zM18.5 6v9H20V6zm-.75-2.25h-7.5v1.5h7.5zm-8.1-.3L8.3 1.65l-1.2.9 1.35 1.8zm.6.3a.75.75 0 0 1-.6-.3l-1.2.9a2.25 2.25 0 0 0 1.8.9zM20 6a2.25 2.25 0 0 0-2.25-2.25v1.5a.75.75 0 0 1 .75.75zm-2.25 11.25A2.25 2.25 0 0 0 20 15h-1.5a.75.75 0 0 1-.75.75zM0 15a2.25 2.25 0 0 0 2.25 2.25v-1.5A.75.75 0 0 1 1.5 15zM6.5 2.25a.75.75 0 0 1 .6.3l1.2-.9a2.25 2.25 0 0 0-1.8-.9zM2.25.75A2.25 2.25 0 0 0 0 3h1.5a.75.75 0 0 1 .75-.75z"
  })));
};
export default SvgFolder;